export default __webpack_public_path__ + "static/media/stats1.0dfc0415.png";